import React, { useContext } from "react";

import { icons } from "constants/icons";
import { Link, useHistory } from "react-router-dom";
import { PAGES } from "constants/pages";
import SettingsIcon from "@mui/icons-material/Settings";
import { AuthContext } from "contexts/authContext";
import { Avatar, Grid, Button } from "@mui/material";
import ReportsButton from "components/Header/ReportsButton";
import CustomizedMenu from "components/CustomizedMenu/CustomizedMenu";
import {
  avatarNameStyle,
  avatarStyle,
  headerStyle,
  settingStyle,
  singOutStyle,
  userMenuStyle,
  btnStyle,
} from "pages/auth/styles";
import { selectCurrentClinician } from "store/ClinicianStore/selectors";
import { useAppSelector } from "hooks/reduxHooks";

type Props = {
  showSettings: boolean;
};

export const Header = ({ showSettings }: Props) => {
  const authContext = useContext(AuthContext);
  const [buttonDisabled, setButtonDisabled] = React.useState(
    window.location.pathname.includes("report")
  );
  const history = useHistory();

  const isFromCronJob = window.location.search.includes("fromCronJob=true");

  const currentClinician = useAppSelector(selectCurrentClinician);

  const onSignOut = () => {
    authContext.signOut();
  };

  const coachToolsOptions = [
    {
      text: "Manage Teams",
      page: "/user-profile?tab=0",
    },
    {
      text: "Sports Preferences",
      page: "/user-profile?tab=0",
    },
    {
      text: "Recommendation Templates",
      page: "/user-profile?tab=1",
    },
    {
      text: "Account Settings",
      page: "/user-profile?tab=0",
    },
    // Billing option will be conditionally added below for non-super_admin users
  ];

  history.listen((data) => {
    if (data.pathname.includes("report")) {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  });

  const emails = [
    "hsiangjung+autoc47@topflightapps.com",
    "colin.mansfieldmd@gmail.com",
  ];

  const isSuperAdmin = currentClinician?.role?.includes("super_admin");

  const menuOptions = isSuperAdmin
    ? coachToolsOptions
    : [
        ...coachToolsOptions,
        {
          text: "Billing",
          page: "/user-profile?tab=3",
        },
      ];

  return (
    <div
      className="w-full min-h-40 flex items-center bg-bgDark py-5 px-6"
      style={headerStyle}
    >
      <Link to={PAGES.homeScreen}>
        <img className="logo" src={icons.logo} alt="logo" />
      </Link>
      {showSettings && !isFromCronJob ? (
        <Grid container justifyContent="end">
          {!isSuperAdmin ? (
            <Grid sx={{ ml: 5, mr: 5 }}>
              <ReportsButton disabled={false} history={history} />
            </Grid>
          ) : null}

          <Grid sx={{ ml: 1, mr: 4 }}>
            <CustomizedMenu buttonText="Coach Tools" options={menuOptions} />
          </Grid>
          <Grid style={userMenuStyle as any}>
            <p style={avatarNameStyle}>
              Hi, {currentClinician?.profileInfo.firstName}{" "}
              {currentClinician?.profileInfo.lastName}
            </p>
            <Link to="/" onClick={onSignOut} style={singOutStyle}>
              Sign out
            </Link>
          </Grid>
          <Avatar src={currentClinician?.imageUrl} style={avatarStyle}>
            H
          </Avatar>
        </Grid>
      ) : null}
    </div>
  );
};
